import {
  Box,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Zoom,
} from "@material-ui/core";
import { Close, ThumbDownAlt, ThumbUpAlt, Update } from "@material-ui/icons";
import { useAuth, useVerifyPermission } from "@airborne/react-admin";
import * as React from "react";
import { FC, Fragment, useState } from "react";
import {
  Button,
  Datagrid,
  ExportButton,
  FormDataConsumer,
  FunctionField,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  required,
  useNotify,
  useRefresh,
} from "react-admin";
import { DetailButton } from "../../../Components/DetailButton";
import { ConfirmButton } from "../../../Components/ConfirmButton";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { useAppDataProvider } from "../../../dataprovider";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { TabbedDatagridProps } from "../../../Models/TabbedDataGridProps";
import { SourcePrematureFailure } from "./Constants";
import { Form } from "react-final-form";
import { EnumField } from "../../../../src/Components/EnumField";
import RefNoUrlField from "../../../Components/LinkButton/RefNoUrlField";
import { ReliabilityAfterPoolVendorTypeChoices } from "../../../Enums/ReliabilityAfterPoolVendorType";
import {
  ReliabilityPrematureFailureChoices,
  ReliabilityPrematureFailureStatus,
} from "../../../../src/Enums/ReliabilityPrematureFailureStatus";
import {
  ReliabilityNotPrematureFailureReasonType,
  ReliabilityPrematureFailureReasonChoices,
  ReliabilityPrematureFailureReasonType,
  ReliabilityPrematureFailureRejectReasonType,
} from "../../../../src/Enums/ReliabilityPrematureFailureReasonType";
import { ReliabilityPrematureFailureUpdateModel } from "../Models/ReliabilityPrematureFailureModel";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
import { ReliabilityBeforePoolVendorTypeChoices } from "../../../../src/Enums/ReliabilityBeforePoolVendorType";
import { formatDate } from "../../../Helper/MomentHelper";

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const { user } = useAuth();
  const refresh = useRefresh(); 

  const AcceptPrematureFailureButton = props => {
    const acceptButtonClick = record => e => {
      let reliabilityPrematureFailure: ReliabilityPrematureFailureUpdateModel =
        new ReliabilityPrematureFailureUpdateModel();
      reliabilityPrematureFailure.Id = record?.id;
      reliabilityPrematureFailure.RequestOrderId = record?.requestOrderId;
      reliabilityPrematureFailure.RequestType = record?.requestType;
      reliabilityPrematureFailure.ReportId = record?.reportId;
      reliabilityPrematureFailure.BeforeRemovalOrderType = record?.beforeRemovalOrderType;
      reliabilityPrematureFailure.BeforeRemovalOrderNumber = record?.beforeRemovalOrderNumber;
      reliabilityPrematureFailure.BeforeRemovalOrderStatus = record?.beforeRemovalOrderStatus;
      reliabilityPrematureFailure.BeforeRemovalVendorType = record?.beforeRemovalVendorType;
      reliabilityPrematureFailure.BeforeRemovalVendor = record?.beforeRemovalVendor;
      reliabilityPrematureFailure.BeforeRemovalCondition = record?.beforeRemovalCondition;
      reliabilityPrematureFailure.AfterRemovalOrderType = record?.afterRemovalOrderType;
      reliabilityPrematureFailure.AfterRemovalOrderNumber = record?.afterRemovalOrderNumber;
      reliabilityPrematureFailure.AfterRemovalOrderStatus = record?.afterRemovalOrderStatus;
      reliabilityPrematureFailure.AfterRemovalVendorType = record?.afterRemovalVendorType;
      reliabilityPrematureFailure.AfterRemovalVendor = record?.afterRemovalVendor;
      reliabilityPrematureFailure.AfterRemovalCondition = record?.afterRemovalCondition;
      reliabilityPrematureFailure.PrematureFailureStatus = ReliabilityPrematureFailureStatus.Confirmed;

      dataProvider
        .putReliabilityPrematureFailure(reliabilityPrematureFailure)
        .then(result => {
          notify(`Reliability Premature Failure Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40, color: "#12824C" }}
        size="medium"
        click={acceptButtonClick(props?.record)}
      >
        <Tooltip TransitionComponent={Zoom} title="Accept Premature Failure">
          <ThumbUpAlt />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const RejectPrematureFailureButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const RejectReliabilityPrematureFailureButtonClick = props => e => {
      let reliabilityPrematureFailure: ReliabilityPrematureFailureUpdateModel =
        new ReliabilityPrematureFailureUpdateModel();
      reliabilityPrematureFailure.Id = props?.record?.id;
      reliabilityPrematureFailure.RequestOrderId = props?.record?.requestOrderId;
      reliabilityPrematureFailure.RequestType = props?.record?.requestType;
      reliabilityPrematureFailure.ReportId = props?.record?.reportId;
      reliabilityPrematureFailure.BeforeRemovalOrderType = props?.record?.beforeRemovalOrderType;
      reliabilityPrematureFailure.BeforeRemovalOrderNumber = props?.record?.beforeRemovalOrderNumber;
      reliabilityPrematureFailure.BeforeRemovalOrderStatus = props?.record?.beforeRemovalOrderStatus;
      reliabilityPrematureFailure.BeforeRemovalVendorType = props?.record?.beforeRemovalVendorType;
      reliabilityPrematureFailure.BeforeRemovalVendor = props?.record?.beforeRemovalVendor;
      reliabilityPrematureFailure.BeforeRemovalCondition = props?.record?.beforeRemovalCondition;
      reliabilityPrematureFailure.AfterRemovalOrderType = props?.record?.afterRemovalOrderType;
      reliabilityPrematureFailure.AfterRemovalOrderNumber = props?.record?.afterRemovalOrderNumber;
      reliabilityPrematureFailure.AfterRemovalOrderStatus = props?.record?.afterRemovalOrderStatus;
      reliabilityPrematureFailure.AfterRemovalVendorType = props?.record?.afterRemovalVendorType;
      reliabilityPrematureFailure.AfterRemovalVendor = props?.record?.afterRemovalVendor;
      reliabilityPrematureFailure.AfterRemovalCondition = props?.record?.afterRemovalCondition;
      reliabilityPrematureFailure.PrematureFailureStatus = ReliabilityPrematureFailureStatus.Rejected;
      reliabilityPrematureFailure.Reason = e.reason;
      reliabilityPrematureFailure.OtherReason = e.otherReason;

      dataProvider
        .putReliabilityPrematureFailure(reliabilityPrematureFailure)
        .then(result => {
          notify(`Reliability Premature Failure Updated`, "success", false, true);
          setOpen(false);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40 }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Reject Premature Failure">
            <ThumbDownAlt />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reject Premature Failure</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={RejectReliabilityPrematureFailureButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Reject Reason"
                        choices={ReliabilityPrematureFailureRejectReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />
                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityPrematureFailureReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        label={"Reject Premature Failure"}
                        size="large"
                        variant="contained"
                        onClick={handleSubmit}
                      >
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const NotPrematureFailureButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const ReliabilityNotPrematureFailureButtonClick = props => e => {
      let reliabilityPrematureFailure: ReliabilityPrematureFailureUpdateModel =
        new ReliabilityPrematureFailureUpdateModel();
      reliabilityPrematureFailure.Id = props?.record?.id;
      reliabilityPrematureFailure.RequestOrderId = props?.record?.requestOrderId;
      reliabilityPrematureFailure.RequestType = props?.record?.requestType;
      reliabilityPrematureFailure.ReportId = props?.record?.reportId;
      reliabilityPrematureFailure.BeforeRemovalOrderType = props?.record?.beforeRemovalOrderType;
      reliabilityPrematureFailure.BeforeRemovalOrderNumber = props?.record?.beforeRemovalOrderNumber;
      reliabilityPrematureFailure.BeforeRemovalOrderStatus = props?.record?.beforeRemovalOrderStatus;
      reliabilityPrematureFailure.BeforeRemovalVendorType = props?.record?.beforeRemovalVendorType;
      reliabilityPrematureFailure.BeforeRemovalVendor = props?.record?.beforeRemovalVendor;
      reliabilityPrematureFailure.BeforeRemovalCondition = props?.record?.beforeRemovalCondition;
      reliabilityPrematureFailure.AfterRemovalOrderType = props?.record?.afterRemovalOrderType;
      reliabilityPrematureFailure.AfterRemovalOrderNumber = props?.record?.afterRemovalOrderNumber;
      reliabilityPrematureFailure.AfterRemovalOrderStatus = props?.record?.afterRemovalOrderStatus;
      reliabilityPrematureFailure.AfterRemovalVendorType = props?.record?.afterRemovalVendorType;
      reliabilityPrematureFailure.AfterRemovalVendor = props?.record?.afterRemovalVendor;
      reliabilityPrematureFailure.AfterRemovalCondition = props?.record?.afterRemovalCondition;
      reliabilityPrematureFailure.PrematureFailureStatus = ReliabilityPrematureFailureStatus.NotPrematureFailure;
      reliabilityPrematureFailure.Reason = e.reason;
      reliabilityPrematureFailure.OtherReason = e.otherReason;

      dataProvider
        .putReliabilityPrematureFailure(reliabilityPrematureFailure)
        .then(result => {
          notify(`Reliability Premature Failure Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40, color: "red" }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Not Premature Failure">
            <Close />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Not Premature Failure</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={ReliabilityNotPrematureFailureButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Not Premature Failure Reason"
                        choices={ReliabilityNotPrematureFailureReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />

                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityPrematureFailureReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button label={"Not Premature Failure"} size="large" variant="contained" onClick={handleSubmit}>
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const DetailsButton = ({ record }) => {
    return <DetailButton record={record} resource={SourcePrematureFailure} />;
  };

  const OptButtonGroup = ({ record }) => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailsButton record={record} />
          {user?.isCustomer === false && (
            <>
              <AcceptPrematureFailureButton record={record} />
              <RejectPrematureFailureButton record={record} />
              <NotPrematureFailureButton record={record} />
            </>
          )}
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <Fragment>
      <Datagrid optimized basePath={SourcePrematureFailure}>
        <OptButtonGroup record={props} />
        <RefNoUrlField source="refNo" label="Ref No" />
        <TextField source="ownerCode" label="Customer" />
        <TextField source="goodsRcvdBatch" label="Goods Received Batch" />
        <TextField source="ac" label="AC Reg" />
        <FunctionField
          label="Request Date"
          sortBy="createdDate"
          render={(record: any) => {
            return record.createdDate === null ? null : formatDate(record.createdDate);
          }}
        />
        <TextField source="pn" label="Pn" />
        <TextField source="sn" label="Sn" />
        <TextField source="pnDescription" label="Pn Description" />
        {!user?.isCustomer && <TextField source="beforeRemovalVendorType" label="Before Removal Vendor Type" />}
        {!user?.isCustomer && <TextField source="afterRemovalVendorType" label="After Removal Vendor Type" />}
        <EnumField
          label={"Premature Failure Status"}
          enumName={"ReliabilityPrematureFailureStatus"}
          source={"prematureFailureStatus"}
        />
        <EnumField label={"Reason"} enumName={"ReliabilityPrematureFailureReasonType"} source={"reason"} />
      </Datagrid>
    </Fragment>
  );
};

const PrematureFailureList = props => {
  useVerifyPermission("customroutes", "prematurefailure.read");
  const { user } = useAuth();

  const ListActions = props => {
    return (
      <TopToolbar {...props}>
        <ExportButton
          resource={props.resource}
          sort={props.currentSort}
          filterValues={props.filterValues}
          maxResults={10000}
        />
      </TopToolbar>
    );
  };

  const exporter = (records, fetchRelatedRecords) => {
    const data = records.map(record => {
      const mappedRecord = {
        //...record,
        "Ref No": record.refNo,
        Customer: record.ownerCode,
        "Requirement Category": record.requirementCategoryText,
        "Ac Reg": record.ac,
        "Request Date": record.createdDate,
        Pn: record.pn,
        Sn: record.sn,
        Chapter: record.chapter,
        "Pn Description": record.pnDescription,
        "Premature Failure Status": ReliabilityPrematureFailureChoices.find(
          x => x.value === record.prematureFailureStatus
        )?.key,
        Reason: ReliabilityPrematureFailureReasonChoices.find(x => x.value === record.reason)?.key,
        "After Removal Order Type": record.afterRemovalOrderType,
        "After Removal Order Number": record.afterRemovalOrderNumber,
        "After Removal Order Status": record.afterRemovalOrderStatus,
        "After Removal Vendor Type": record.afterRemovalVendorType,
        "After Removal Vendor": record.afterRemovalVendor,
        "After Removal Condition": record.afterRemovalCondition,
        "Reliability Report Created Date": record.reliabilityReportCreatedDate,
      };

      // Non Customer fields
      if (!user?.isCustomer) {
        mappedRecord["Before Removal Order Type"] = record.beforeRemovalOrderType;
        mappedRecord["Before Removal Order Number"] = record.beforeRemovalOrderNumber;
        mappedRecord["Before Removal Order Status"] = record.beforeRemovalOrderStatus;
        mappedRecord["Before Removal Vendor Type"] = record.beforeRemovalVendorType;
        mappedRecord["Before Removal Vendor"] = record.beforeRemovalVendor;
        mappedRecord["Before Removal Condition"] = record.beforeRemovalCondition;
        mappedRecord["Sub Category"] = record.subCategory;
      }

      return mappedRecord;
    });

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "Premature Failure List");
  };

  const prematureFailureChoices = [{ key: "ALL" }, ...ReliabilityPrematureFailureChoices];

  const ttFilters = [
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />,
    <TextInput label="Ac Reg" source="ac__contains" alwaysOn />,
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <TextInput label="Sn" source="sn__contains" alwaysOn />,
    <TextInput label="Pn Description" source="pnDescription__contains" alwaysOn />,
    <SelectInput
      label="Before Removal Vendor Type"
      source="beforeRemovalVendorType__eq"
      choices={ReliabilityBeforePoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="After Removal Vendor Type"
      source="afterRemovalVendorType__eq"
      choices={ReliabilityAfterPoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="Premature Failure Status"
      source="prematureFailureStatus__eq"
      choices={prematureFailureChoices}
      optionValue="value"
      optionText="key"
      alwaysOn
    />,
  ];

  const customerFilters = [
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />,
    <TextInput label="Ac Reg" source="ac__contains" alwaysOn />,
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <TextInput label="Sn" source="sn__contains" alwaysOn />,
    <TextInput label="Pn Description" source="pnDescription__contains" alwaysOn />,
    <SelectInput
      label="Premature Failure Status"
      source="prematureFailureStatus__eq"
      choices={prematureFailureChoices}
      optionValue="value"
      optionText="key"
      alwaysOn
    />,
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <PoolList
          {...props}
          hasCreate={false}
          exporter={exporter}
          actions={<ListActions />}
          bulkActionButtons={false}
          resource={SourcePrematureFailure}
          title={"Premature Failure List"}
          sort={DefaultCreatedDateSort}
          perPage={DefaultPerPageSize}
          filters={!user?.isCustomer ? ttFilters : customerFilters}
          filter={props?.filterParams}
        >
          <TabbedDatagrid />
        </PoolList>
      </Grid>
    </Grid>
  );
};

export default PrematureFailureList;
